import { useState, useEffect, useCallback } from 'react'
import { analysesApi } from '../api'

/**
 * Custom hook for fetching and managing dashboard data
 * Auto-refreshes every 10 seconds
 *
 * @param {boolean} autoRefresh - Enable auto-refresh (default: true)
 * @returns {Object} { data, loading, error, refetch }
 */
export const useAnalysisDashboard = (autoRefresh = true) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchDashboard = useCallback(async () => {
    try {
      setError(null)
      const response = await analysesApi.getDashboard()
      setData(response.data)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  // Manual refetch function
  const refetch = useCallback(() => {
    setLoading(true)
    fetchDashboard()
  }, [fetchDashboard])

  // Initial fetch
  useEffect(() => {
    fetchDashboard()
  }, [fetchDashboard])

  // Auto-refresh every 10 seconds
  useEffect(() => {
    if (!autoRefresh) return

    const intervalId = setInterval(() => {
      fetchDashboard()
    }, 10000)

    return () => clearInterval(intervalId)
  }, [autoRefresh, fetchDashboard])

  return { data, loading, error, refetch }
}
